var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "80iagnxn2a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 218",
    style: {
      fill: "#c10000"
    },
    d: "M0 0h36v36H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 214",
    style: {
      clipPath: "url(#80iagnxn2a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 110",
    d: "M19.99 19.99h-3.635V9.086h3.635m0 18.172h-3.635v-3.634h3.635M18.172 0a18.172 18.172 0 1 0 18.173 18.172A18.172 18.172 0 0 0 18.172 0",
    transform: "translate(-.026)",
    style: {
      fill: "#c10000"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.41c7d5d1e0bc8c75c51f404fa8eef8aa.svg";
export { ForwardRef as ReactComponent };